import React, { FC } from 'react';
import { EFilterType, IFilterComponentProps } from './filter.types';
import usePartners from 'components/Partners/hooks/usePartners';
import { Skeleton } from '@mui/material';
import FilterAutocompleteSelection from 'components/Filter/FilterAutocompleteSelection';

const PartnerFilter: FC<IFilterComponentProps<EFilterType.PARTNERS>> = ({ value, onChange }) => {
  const { partners, loading, error } = usePartners();
  const options = partners.map(partner => ({
    ...partner,
    title: partner.name,
  }));

  const handleSelectionChange = (selectedItems?: string | string[]) => {
    const newSelection = selectedItems as string[] | undefined;
    const updatedSelection = newSelection?.map(item => item) || [];
    onChange(updatedSelection);
  };

  return (
    <>
      {loading ? (
        <Skeleton variant="rounded" width="100%" height={30} />
      ) : (
        <FilterAutocompleteSelection
          label="Partners"
          placeholder="All partners"
          closeAfterSelection
          enableAddNewItem
          multiple
          itemName="partner"
          items={options}
          errorMessage={error?.message}
          hasError={!!error}
          selected={value || []}
          onSelectionChange={handleSelectionChange}
        />
      )}
    </>
  );
};

export default PartnerFilter;
